import React, { Component } from 'react'
import { Button } from 'react-bootstrap'
import SelectSearchLayout from '../../../layouts/select-search'
import { alarmOperations } from '../../../../state/ducks/alarms'
import { connect } from 'react-redux'
import * as PropTypes from 'prop-types'
import { Session } from '../../../../state/utils/session'

class AutomationAlarmsForm extends Component {
  constructor (props) {
    super(props)

    // set state
    this.state = {
      session: new Session()
    }

    // handlers
    this.handleCheckbox = this.handleCheckbox.bind(this)
    this.returnOptions = this.returnOptions.bind(this)
    this.onAlarmSarchKeywordChange = this.onAlarmSarchKeywordChange.bind(this)
    this.onSelectAlarm = this.onSelectAlarm.bind(this)
    this.removeAlarm = this.removeAlarm.bind(this)
  }

  handleCheckbox (event) {
    if (!this.props.automation.for_all_alarms === true) {
      this.props.onChange('alarms', [])
    }
    setTimeout(() => {
      this.props.onChange('for_all_alarms', !this.props.automation.for_all_alarms)
    }, 100)
  }

  returnOptions () {
    const options = []
    this.props.alarms_list.forEach(element => {
      const groupAdded = this.props.automation.alarms.find(p => p.toString() === element.id.toString())
      if (!groupAdded) {
        options.push({
          value: element.id + '|' + element.name,
          label: element.name + '(' + element.id + ')'
        })
      }
    })
    return options
  }

  onAlarmSarchKeywordChange (keyword) {
    this.returnOptions()
    this.props.fetchAlarms({ search: keyword })
  }

  onSelectAlarm (item) {
    const addedAlarms = this.props.automation.alarms
    const split_ = item.value.split('|')
    addedAlarms.push({
      id: split_[0],
      name: split_[1]
    })
    this.props.onChange('alarms', addedAlarms)
  }

  removeAlarm (index) {
    const addedAlarms = this.props.automation.alarms
    addedAlarms.splice(index, 1)
    this.props.onChange('alarms', addedAlarms)
  }

  renderAlarms () {
    return (
            <>
                <table className="table">
                    <tbody>
                    {
                        this.props.automation.alarms.map((alarm, index) => {
                          return (
                                <tr key={index} className="border">
                                    <td style={{ width: '20px' }}>
                                        <i className="fa fa-th fa-2x"></i>
                                    </td>
                                    <td>
                                        <small className="font-w400">{alarm.name}  ({alarm.id})</small>
                                        <div className="font-w400 text-muted">
                                            <small>---</small>
                                        </div>
                                    </td>
                                    <td style={{ width: '20px' }}>
                                        <Button
                                            variant="danger"
                                            className="float-right"
                                            onClick={this.removeAlarm.bind(this, index)}
                                        >
                                            <i className="fa fa-trash"/>
                                        </Button>
                                    </td>
                                </tr>
                          )
                        })
                    }
                    </tbody>
                </table>
                {/* <pre> */}
                {/*    <code className="json"> */}
                {/*        {JSON.stringify(this.props.automation.alarms)} */}
                {/*    </code> */}
                {/* </pre> */}
            </>
    )
  }

  render () {
    return (
            <>
                <div className="form-group">
                    <div className="col-sm-8 col-sm-offset-2 text-center" style={{ minHeight: '70px' }}>
                        <div className="">
                            <label className="css-input switch switch-success">
                                <input
                                    type="checkbox"
                                    value={this.props.automation.for_all_alarms}
                                    checked={this.props.automation.for_all_alarms}
                                    onChange={this.handleCheckbox}
                                />
                                <span></span> Add all alarms
                            </label>
                        </div>
                    </div>
                    {
                        !this.props.automation.for_all_alarms
                          ? <>
                                <div className="form-group">
                                    <div className="col-sm-6 col-sm-offset-3">
                                        <div className="form-material">
                                            <SelectSearchLayout
                                                getOptions={this.returnOptions}
                                                onSearchChange={this.onAlarmSarchKeywordChange}
                                                onSelectItem={this.onSelectAlarm}
                                            />
                                            <label htmlFor="input-groups">Search alarms</label>
                                        </div>
                                        {this.renderAlarms()}
                                    </div>
                                </div>
                            </>
                          : null
                    }
                </div>
            </>
    )
  }
}

// Set propTypes
AutomationAlarmsForm.propTypes = {
  alarms_list: PropTypes.array.isRequired,
  fetchAlarms: PropTypes.func.isRequired
}

// Set defaultProps
AutomationAlarmsForm.defaultProps = {
  alarms_list: [],
  automation: [],
  onChange: () => {
  }
}

// mapStateToProps
const mapStateToProps = (state) => ({
  alarms_list: state.alarms.fetchAlarmsReducer.data.results
})

// mapStateToProps
const mapDispatchToProps = {
  fetchAlarms: alarmOperations.list
}

// Export Class
const _AutomationAlarmsForm = connect(mapStateToProps,
  mapDispatchToProps)(AutomationAlarmsForm)
export { _AutomationAlarmsForm as AutomationAlarmsForm }
